import style from "./style.css";
import { Link } from "preact-router/match";
import Match from "preact-router/match";

const PageLinks = () => (
  <div class={style.home}>
    <div class={style.button_group}>
      <span>Sort By:</span>
      <Link activeClassName={style.active} href="/">
        Top Games
      </Link>
      <Match path="/date">
        {({ url }) =>
          url.includes("date") ? (
            <Link className={style.active} href="/date">
              Date
            </Link>
          ) : (
            <Link activeClassName={style.active} href="/date">
              Date
            </Link>
          )
        }
      </Match>
      <Link activeClassName={style.active} href="/live">
        Live
      </Link>
    </div>
  </div>
);

export default PageLinks;
